module.exports = __webpack_public_path__ + "static/media/BwModelica-Regular.3bc116fb.otf";